(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) {
    root.NBBWelcomePopup = api;
    var boot = function () {
      var popupRoot = root.document && root.document.getElementById('nbb-welcome-popup');
      if (popupRoot && root.NBBWelcomePopupCore && root.NBBWatchProfileCore) {
        api.create(popupRoot, { core: root.NBBWelcomePopupCore, profileCore: root.NBBWatchProfileCore });
      }
    };
    if (root.document && root.document.readyState === 'loading') root.document.addEventListener('DOMContentLoaded', boot);
    else boot();
  }
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  var activeInstance = null;
  var STAGES = ['email', 'reward', 'brand', 'model', 'size', 'usecase', 'material', 'done'];
  var PROFILE_STAGES = ['brand', 'model', 'size', 'usecase', 'material'];
  var BACK_STAGES = PROFILE_STAGES.concat(['done']);
  var STAGE_META = {
    email: { label: 'WELCOME · 01', progress: '12%' },
    reward: { label: 'YOUR GIFT · 02', progress: '26%' },
    brand: { label: 'YOUR WATCH · 01 OF 05', progress: '40%' },
    model: { label: 'YOUR WATCH · 02 OF 05', progress: '54%' },
    size: { label: 'YOUR WATCH · 03 OF 05', progress: '68%' },
    usecase: { label: 'YOUR ROUTINE · 04 OF 05', progress: '82%' },
    material: { label: 'YOUR STYLE · 05 OF 05', progress: '94%' },
    done: { label: 'ALL SET', progress: '100%' }
  };
  var ONCE_ACTIONS = new Set([
    'eligible', 'teaser_viewed', 'popup_opened', 'email_attempted', 'signup_succeeded',
    'offer_revealed', 'coupon_copied', 'profile_started', 'profile_completed', 'dismissed',
    'interaction_started', 'scratch_started'
  ]);
  var ANALYTICS_EVENTS = {
    eligible: 'popup_eligible',
    teaser_viewed: 'popup_teaser_viewed',
    popup_opened: 'popup_opened',
    step_viewed: 'popup_step_viewed',
    interaction_started: 'popup_interaction_started',
    scratch_started: 'popup_scratch_started',
    email_attempted: 'popup_email_attempted',
    signup_succeeded: 'popup_signup_completed',
    offer_revealed: 'popup_offer_revealed',
    coupon_copied: 'popup_coupon_copied',
    profile_started: 'popup_profile_started',
    profile_step_saved: 'popup_profile_step_completed',
    profile_step_skipped: 'popup_profile_step_skipped',
    profile_completed: 'popup_profile_completed',
    dismissed: 'popup_dismissed',
    error: 'popup_error'
  };
  var PROFILE_STEP_NUMBERS = { brand: 1, model: 2, size: 3, usecase: 4, material: 5 };
  var STAGE_NUMBERS = { email: 1, reward: 2, brand: 3, model: 4, size: 5, usecase: 6, material: 7, done: 8 };
  var FIXED_SURFACE_SESSION_KEY = 'nbb_fixed_popup_session_v1';
  var FIXED_SURFACE_SESSION_MS = 30 * 60 * 1000;

  function create(root, dependencies) {
    if (!root) throw new Error('NBB welcome popup root is required');
    if (activeInstance) activeInstance.destroy();

    dependencies = dependencies || {};
    var doc = root.ownerDocument;
    var win = doc.defaultView;
    var core = dependencies.core || win.NBBWelcomePopupCore;
    if (!core) throw new Error('NBBWelcomePopupCore is required');
    var profileCore = dependencies.profileCore || win.NBBWatchProfileCore;
    if (!profileCore) throw new Error('NBBWatchProfileCore is required');

    var fetcher = dependencies.fetch || (win.fetch && win.fetch.bind(win));
    var now = dependencies.now || Date.now;
    var random = dependencies.random || Math.random;
    var setTimer = dependencies.setTimeout || win.setTimeout.bind(win);
    var clearTimer = dependencies.clearTimeout || win.clearTimeout.bind(win);
    var clipboard = dependencies.clipboard || (win.navigator && win.navigator.clipboard);
    var analytics = dependencies.analytics || win.NBBAnalytics;
    var storage = dependencies.storage || win.localStorage;
    var overlay = root.querySelector('[data-popup-overlay]');
    var dialog = root.querySelector('[role="dialog"]');
    var teaser = root.querySelector('[data-welcome-teaser]');
    var teaserDismiss = root.querySelector('[data-dismiss-welcome-teaser]');
    var emailForm = root.querySelector('[data-email-form]');
    var emailInput = root.querySelector('[name="email"]');
    var emailError = root.querySelector('[data-email-error]');
    var submitButton = emailForm && emailForm.querySelector('[type="submit"]');
    var experimentVersion = root.dataset.experimentVersion || 'commercial_popup_ab_v1';
    var keyPrefix = 'nbb_welcome_popup_' + experimentVersion.replace(/^commercial_popup_/, '');
    var keys = {
      variant: keyPrefix + '_variant',
      dismissed: keyPrefix + '_dismissed',
      teaserDismissed: keyPrefix + '_teaser_dismissed',
      teaserDismissCount: keyPrefix + '_teaser_dismiss_count',
      completed: keyPrefix + '_completed'
    };
    var listeners = [];
    var timers = [];
    var emitted = new Set();
    var viewedStages = new Set();
    var previousFocus = null;
    var turnstileWidgetId = null;
    var scratchInstance = null;
    var pendingProfileSave = null;
    var profileBusyButtons = [];
    var state = {
      variant: '',
      stage: 'email',
      signup: null,
      email: '',
      couponCode: '',
      profileClaimToken: '',
      profile: {},
      profileCompletion: '',
      selectedModel: null,
      history: [],
      turnstileToken: '',
      submitting: false,
      profileSubmitting: false,
      offerRevealed: false,
      testMode: false,
      destroyed: false,
      initialized: false
    };

    if (!overlay || !dialog || !teaser || !emailForm || !emailInput) throw new Error('NBB welcome popup markup is incomplete');

    function safeGet(key) {
      try { return storage.getItem(key); } catch (_error) { return null; }
    }

    function safeSet(key, value) {
      try { storage.setItem(key, String(value)); } catch (_error) {}
    }

    function teaserDismissalCount() {
      var storedCount = Math.floor(Number(safeGet(keys.teaserDismissCount) || 0));
      if (storedCount > 0) return storedCount;
      return Number(safeGet(keys.teaserDismissed) || 0) > 0 ? 1 : 0;
    }

    function fixedSurfaceClaimed() {
      var claimedAt = Number(safeGet(FIXED_SURFACE_SESSION_KEY) || 0);
      return claimedAt > 0 && now() - claimedAt < FIXED_SURFACE_SESSION_MS;
    }

    function claimFixedSurface() {
      safeSet(FIXED_SURFACE_SESSION_KEY, now());
    }

    function on(target, eventName, handler, options) {
      if (!target) return;
      target.addEventListener(eventName, handler, options);
      listeners.push(function () { target.removeEventListener(eventName, handler, options); });
    }

    function analyticsInput(surface, errorCategory) {
      var input = {
        popupVersion: experimentVersion,
        popupVariant: state.variant,
        surface: surface || 'modal',
        pageType: root.dataset.pageType || 'unknown',
        locale: root.dataset.locale || 'en'
      };
      if (errorCategory) input.errorCategory = errorCategory;
      return input;
    }

    function emit(action, surface, errorCategory) {
      if (state.testMode) return;
      if (ONCE_ACTIONS.has(action) && emitted.has(action)) return;
      var detail;
      try { detail = core.analyticsDetail(action, analyticsInput(surface, errorCategory)); }
      catch (_error) { return; }
      if (ONCE_ACTIONS.has(action)) emitted.add(action);
      root.dispatchEvent(new win.CustomEvent('nbb:welcome-popup', { bubbles: true, detail: detail }));
      var eventName = ANALYTICS_EVENTS[action];
      if (!eventName || !analytics || typeof analytics.publish !== 'function') return;
      var payload = {
        popup_id: 'commercial_welcome',
        popup_version: detail.popup_version,
        popup_variant: detail.popup_variant,
        popup_surface: detail.surface || 'modal',
        experiment_id: 'welcome_popup_premium_vs_scratch',
        page_type: detail.page_type,
        locale: detail.locale
      };
      if (action === 'popup_opened') payload.popup_trigger = detail.surface === 'teaser' ? 'teaser' : 'auto';
      if (detail.error_category) payload.error_category = detail.error_category;
      if (eventName === 'popup_step_viewed') {
        payload.step_id = state.stage;
        payload.step_number = STAGE_NUMBERS[state.stage] || 0;
      } else if (eventName === 'popup_profile_started' || eventName === 'popup_profile_step_completed' ||
          eventName === 'popup_profile_step_skipped' || eventName === 'popup_profile_completed') {
        payload.step_id = state.stage;
        payload.step_number = PROFILE_STEP_NUMBERS[state.stage] || 0;
      }
      analytics.publish(eventName, payload);
    }

    function emitStepViewed() {
      if (viewedStages.has(state.stage)) return;
      viewedStages.add(state.stage);
      emit('step_viewed', 'modal');
    }

    function startInteraction() {
      emit('interaction_started', 'modal');
    }

    function focusableElements() {
      return Array.prototype.slice.call(dialog.querySelectorAll(
        'button:not([disabled]):not([hidden]), input:not([disabled]):not([hidden]), a[href], [tabindex]:not([tabindex="-1"])'
      )).filter(function (element) { return !element.closest('[hidden]'); });
    }

    function showStage(stage, options) {
      if (STAGES.indexOf(stage) === -1) return;
      if (typeof options === 'boolean') options = { focus: options };
      options = options || {};
      if (state.stage !== stage && options.remember !== false) state.history.push(state.stage);
      state.stage = stage;
      Array.prototype.forEach.call(root.querySelectorAll('[data-stage]'), function (element) {
        element.hidden = element.dataset.stage !== stage;
      });
      var meta = STAGE_META[stage];
      var stageLabel = root.querySelector('[data-stage-label]');
      var progress = root.querySelector('[data-progress-fill]');
      if (stageLabel) stageLabel.textContent = meta.label;
      if (progress) progress.style.width = meta.progress;
      var profileCoupon = root.querySelector('[data-profile-coupon-chip]');
      if (profileCoupon) profileCoupon.hidden = PROFILE_STAGES.indexOf(stage) === -1;
      var back = root.querySelector('[data-profile-back]');
      if (back) back.hidden = BACK_STAGES.indexOf(stage) === -1 || !state.history.length;
      var current = root.querySelector('[data-stage="' + stage + '"]');
      var target = current && current.querySelector('input, button, [tabindex]');
      if (!overlay.hidden) emitStepViewed();
      if (options.focus !== false && !overlay.hidden && target) target.focus();
    }

    function goBack() {
      if (state.profileSubmitting || !state.history.length) return;
      var previousStage = state.history.pop();
      profileErrorPanel(false);
      showStage(previousStage, { remember: false });
      emit('profile_back_clicked', 'modal');
    }

    function ensureTurnstile() {
      if (dependencies.turnstileToken) {
        state.turnstileToken = dependencies.turnstileToken;
        return;
      }
      if (turnstileWidgetId !== null || !root.dataset.turnstileSiteKey || !win.turnstile || typeof win.turnstile.render !== 'function') return;
      var container = root.querySelector('[data-turnstile]');
      if (!container) return;
      turnstileWidgetId = win.turnstile.render(container, {
        sitekey: root.dataset.turnstileSiteKey,
        action: root.dataset.turnstileAction || 'welcome_popup_signup',
        theme: 'light',
        size: 'flexible',
        callback: function (token) { state.turnstileToken = token || ''; },
        'expired-callback': function () { state.turnstileToken = ''; },
        'error-callback': function () { state.turnstileToken = ''; },
        'timeout-callback': function () { state.turnstileToken = ''; }
      });
    }

    function resetTurnstile() {
      state.turnstileToken = dependencies.turnstileToken || '';
      if (turnstileWidgetId !== null && win.turnstile && typeof win.turnstile.reset === 'function') {
        try { win.turnstile.reset(turnstileWidgetId); } catch (_error) {}
      }
    }

    function open(trigger) {
      if (state.destroyed || !state.initialized || !overlay.hidden) return;
      previousFocus = trigger && trigger.nodeType ? trigger : doc.activeElement;
      overlay.hidden = false;
      overlay.classList.add('is-opening');
      doc.body.classList.add('nbb-wp-scroll-locked');
      ensureTurnstile();
      dialog.focus();
      emit('popup_opened', trigger === teaser || trigger === 'teaser' ? 'teaser' : 'modal');
      emitStepViewed();
      timers.push(setTimer(function () { overlay.classList.remove('is-opening'); }, 500));
    }

    function close(reason) {
      if (overlay.hidden) return;
      overlay.hidden = true;
      overlay.classList.remove('is-opening');
      doc.body.classList.remove('nbb-wp-scroll-locked');
      if (!safeGet(keys.completed)) safeSet(keys.dismissed, now());
      emit('dismissed', 'modal');
      if (previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus();
      previousFocus = null;
    }

    function dismissTeaser() {
      if (state.destroyed || !state.initialized || !overlay.hidden) return;
      safeSet(keys.teaserDismissCount, teaserDismissalCount() + 1);
      safeSet(keys.teaserDismissed, now());
      timers.splice(0).forEach(function (timer) { clearTimer(timer); });
      root.hidden = true;
      state.initialized = false;
      emit('dismissed', 'teaser');
    }

    function renderCoupon() {
      Array.prototype.forEach.call(root.querySelectorAll('[data-coupon-code]'), function (element) {
        element.textContent = state.couponCode;
      });
    }

    function revealOffer(method) {
      if (state.offerRevealed || !state.couponCode) return;
      state.offerRevealed = true;
      var reward = root.querySelector('[data-reward]');
      var coupon = root.querySelector('[data-coupon]');
      var invitation = root.querySelector('[data-profile-invitation]');
      if (reward) reward.classList.add('is-code-visible');
      if (coupon) coupon.hidden = false;
      if (invitation) invitation.hidden = false;
      emit('offer_revealed', 'modal');
      var copy = root.querySelector('[data-copy-coupon]');
      if (copy && method === 'premium') copy.focus();
    }

    function prepareReward() {
      renderCoupon();
      showStage('reward');
      var reward = root.querySelector('[data-reward]');
      if (reward) reward.hidden = state.variant === 'premium';
      if (state.variant === 'premium') {
        revealOffer('premium');
        return;
      }
      var scratchFactory = dependencies.scratch || win.NBBWelcomeScratch;
      if (scratchFactory && typeof scratchFactory.create === 'function') {
        scratchInstance = scratchFactory.create(root.querySelector('[data-scratch-canvas]'), {
          coin: root.querySelector('[data-scratch-coin]'),
          threshold: 0.5,
          reducedMotion: Boolean(win.matchMedia && win.matchMedia('(prefers-reduced-motion: reduce)').matches),
          onStart: function () {
            startInteraction();
            emit('scratch_started', 'modal');
          },
          onComplete: function () { celebrateScratch('scratch'); }
        });
      }
    }

    function celebrateScratch(method) {
      if (state.offerRevealed) return;
      var reward = root.querySelector('[data-reward]');
      if (reward) reward.classList.add('is-celebrating');
      var reduced = Boolean(win.matchMedia && win.matchMedia('(prefers-reduced-motion: reduce)').matches);
      timers.push(setTimer(function () { revealOffer(method || 'button'); }, reduced ? 20 : 1750));
    }

    async function submitEmail(event) {
      event.preventDefault();
      if (state.submitting) return;
      startInteraction();
      var email = emailInput.value;
      if (!core.isValidEmail(email)) {
        emailError.textContent = 'Please enter a valid email address.';
        emailError.hidden = false;
        emailInput.setAttribute('aria-invalid', 'true');
        emailInput.focus();
        emit('error', 'modal', 'invalid_email');
        return;
      }
      if (!fetcher || !root.dataset.signupEndpoint) {
        emailError.textContent = 'This welcome gift is not connected yet. Please try again shortly.';
        emailError.hidden = false;
        emit('error', 'modal', 'missing_endpoint');
        return;
      }

      state.email = core.normalizeEmail(email);
      state.submitting = true;
      emailError.hidden = true;
      emailInput.removeAttribute('aria-invalid');
      if (submitButton) submitButton.disabled = true;
      emit('email_attempted', 'modal');

      try {
        var payload = core.buildSignupPayload({ email: state.email, variant: state.variant }, {
          consent: true,
          locale: root.dataset.locale || 'en',
          sourceUrl: win.location.href,
          experimentVersion: experimentVersion,
          turnstileToken: state.turnstileToken || dependencies.turnstileToken || ''
        });
        var response = await fetcher(root.dataset.signupEndpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload)
        });
        if (!response || !response.ok) throw new Error('signup_request_failed');
        var result = await response.json();
        var couponCode = result && typeof result.couponCode === 'string' ? result.couponCode.trim() : '';
        var claimToken = result && typeof result.profileClaimToken === 'string' ? result.profileClaimToken.trim() : '';
        if (!result || result.ok !== true || result.couponPercent !== 10 || !couponCode || !claimToken) throw new Error('signup_response_invalid');
        state.signup = result;
        state.couponCode = couponCode;
        state.profileClaimToken = claimToken;
        safeSet(keys.completed, now());
        emit('signup_succeeded', 'modal');
        prepareReward();
      } catch (_error) {
        emailError.textContent = 'We couldn’t save your welcome gift just now. Please try once more.';
        emailError.hidden = false;
        resetTurnstile();
        emit('error', 'modal', 'signup_failed');
      } finally {
        state.submitting = false;
        if (submitButton) submitButton.disabled = false;
      }
    }

    async function copyCoupon(label, codeElement) {
      if (!state.couponCode) return;
      try {
        if (!clipboard || typeof clipboard.writeText !== 'function') throw new Error('clipboard_unavailable');
        await clipboard.writeText(state.couponCode);
        if (label) label.textContent = 'Copied!';
        emit('coupon_copied', 'modal');
      } catch (_error) {
        codeElement = codeElement || root.querySelector('[data-coupon-code]');
        if (codeElement && doc.createRange && win.getSelection) {
          var range = doc.createRange();
          range.selectNodeContents(codeElement);
          var selection = win.getSelection();
          selection.removeAllRanges();
          selection.addRange(range);
        }
        if (label) label.textContent = 'Press and hold to copy';
      }
    }

    function showDone() {
      showStage('done');
    }

    function profileErrorPanel(show) {
      var panel = root.querySelector('[data-profile-error-panel]');
      if (panel) panel.hidden = !show;
    }

    function profileAnswerButtons() {
      var stage = root.querySelector('[data-stage="' + state.stage + '"]');
      return stage ? Array.prototype.slice.call(stage.querySelectorAll(
        '[data-brand-choice], [data-model-choice], [data-model-unlisted], ' +
        '[data-size-choice], [data-size-not-sure], [data-usecase-choice], [data-material-choice]'
      )) : [];
    }

    function setProfileBusy(busy) {
      state.profileSubmitting = busy;
      if (busy) profileBusyButtons = profileAnswerButtons();
      profileBusyButtons.forEach(function (button) { button.disabled = busy; });
      if (!busy) profileBusyButtons = [];
    }

    function safeProfileResponse(result, expectedCompletion) {
      var allowed = ['brand', 'model', 'size', 'usecase', 'material'];
      return result && result.ok === true && result.completion === expectedCompletion &&
        Array.isArray(result.savedFields) && result.savedFields.every(function (field) { return allowed.indexOf(field) > -1; });
    }

    function renderModelOptions() {
      var container = root.querySelector('[data-model-results]');
      var search = root.querySelector('[data-model-search]');
      if (!container) return;
      container.textContent = '';
      profileCore.modelsForBrand(state.profile.brand, search ? search.value : '').forEach(function (model) {
        var button = doc.createElement('button');
        button.type = 'button';
        button.dataset.modelChoice = model.name;
        button.textContent = model.name;
        container.appendChild(button);
      });
    }

    function renderSizeOptions(model) {
      var container = root.querySelector('[data-size-options]');
      if (!container) return;
      container.textContent = '';
      (model && Array.isArray(model.sizes) ? model.sizes : []).forEach(function (size) {
        var button = doc.createElement('button');
        button.type = 'button';
        button.dataset.sizeChoice = size;
        button.textContent = size;
        container.appendChild(button);
      });
    }

    async function patchProfile(candidate, completion, nextStage, failedField) {
      if (state.profileSubmitting || !fetcher || !root.dataset.profileEndpoint) return false;
      var normalized;
      try {
        normalized = profileCore.normalizeAnswers(candidate);
        var payload = core.buildProfilePayload(state.profileClaimToken, normalized, completion);
        pendingProfileSave = {
          candidate: normalized,
          completion: completion,
          nextStage: nextStage,
          failedField: failedField || ''
        };
        setProfileBusy(true);
        profileErrorPanel(false);
        var response = await fetcher(root.dataset.profileEndpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload)
        });
        if (!response || !response.ok) throw new Error('profile_request_failed');
        var result = await response.json();
        if (!safeProfileResponse(result, completion)) throw new Error('profile_response_invalid');
        state.profile = normalized;
        state.profileCompletion = completion;
        pendingProfileSave = null;
        if (completion === 'started') emit('profile_started', 'modal');
        else if (completion === 'complete') emit('profile_completed', 'modal');
        else emit('profile_step_saved', 'modal');
        if (nextStage === 'model') renderModelOptions();
        if (nextStage === 'size') renderSizeOptions(state.selectedModel);
        if (nextStage === 'done') showDone();
        else showStage(nextStage);
        return true;
      } catch (_error) {
        emit('error', 'modal', 'profile_failed');
        profileErrorPanel(true);
        return false;
      } finally {
        setProfileBusy(false);
      }
    }

    function startProfile() {
      showStage('brand');
      patchProfile({}, 'started', 'brand', '');
    }

    function chooseBrand(value) {
      var candidate = Object.assign({}, state.profile, { brand: value });
      delete candidate.model;
      delete candidate.size;
      state.selectedModel = null;
      patchProfile(candidate, 'partial', 'model', 'brand');
    }

    function chooseModel(value) {
      var model = profileCore.modelsForBrand(state.profile.brand, '').find(function (item) { return item.name === value; });
      state.selectedModel = model || { name: value, sizes: [] };
      var candidate = Object.assign({}, state.profile, { model: value });
      delete candidate.size;
      var nextStage = 'usecase';
      if (model && model.sizes.length === 1) candidate.size = model.sizes[0];
      else if (model && model.sizes.length > 1) nextStage = 'size';
      patchProfile(candidate, 'partial', nextStage, 'model');
    }

    function chooseSize(value) {
      patchProfile(Object.assign({}, state.profile, { size: value }), 'partial', 'usecase', 'size');
    }

    function chooseUseCase(value) {
      patchProfile(Object.assign({}, state.profile, { usecase: value }), 'partial', 'material', 'usecase');
    }

    function chooseMaterial(value) {
      patchProfile(Object.assign({}, state.profile, { material: value }), 'complete', 'done', 'material');
    }

    function retryProfileSave() {
      if (!pendingProfileSave) return;
      var pending = pendingProfileSave;
      pendingProfileSave = null;
      patchProfile(pending.candidate, pending.completion, pending.nextStage, pending.failedField);
    }

    function continueWithoutProfileAnswer() {
      if (!pendingProfileSave) return;
      var pending = pendingProfileSave;
      pendingProfileSave = null;
      profileErrorPanel(false);
      emit('profile_step_skipped', 'modal');
      if (pending.completion === 'complete') patchProfile(state.profile, 'complete', 'done', '');
      else if (pending.nextStage === 'done') showDone();
      else showStage(pending.nextStage || state.stage);
    }

    function initialize(identified) {
      if (state.destroyed) return;
      var pathname = win.location.pathname;
      if (root.dataset.scope === 'homepage' && !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?$/i.test(pathname)) return;
      if (doc.getElementById('nbb-blog-guide')) return;
      try { state.testMode = new URL(win.location.href).searchParams.get('welcome_popup_test') === '1'; }
      catch (_error) { state.testMode = false; }
      var cooldownMs = Number(root.dataset.cooldownMs) || 259200000;
      var teaserDismissedAt = Number(safeGet(keys.teaserDismissed) || 0);
      var teaserDismissCount = teaserDismissalCount();
      var teaserCooldownMs = core.teaserCooldownMs(teaserDismissCount || 1);
      if (!state.testMode && teaserDismissedAt > 0 && now() - teaserDismissedAt < teaserCooldownMs) return;
      if (!state.testMode && fixedSurfaceClaimed()) return;
      var completed = Boolean(safeGet(keys.completed));
      var dismissedAt = Number(safeGet(keys.dismissed) || 0);
      var eligibility = core.evaluateEligibility({
        route: pathname,
        identified: state.testMode ? false : identified === true,
        completed: state.testMode ? false : completed,
        dismissedAt: state.testMode ? 0 : dismissedAt,
        now: now(),
        cooldownMs: cooldownMs
      });
      if (!eligibility.eligible && eligibility.reason !== 'cooldown') return;

      var forced = root.dataset.forceVariant || '';
      try { forced = new URL(win.location.href).searchParams.get('welcome_popup_variant') || forced; } catch (_error) {}
      var stored = safeGet(keys.variant);
      state.variant = core.resolveVariant({
        forcedVariant: forced,
        storedVariant: stored,
        randomValue: random(),
        allocation: Number(root.dataset.allocation)
      });
      if (!forced && !stored) safeSet(keys.variant, state.variant);
      root.classList.add(state.variant === 'scratch' ? 'is-scratch' : 'is-premium');
      root.hidden = false;
      state.initialized = true;
      if (!state.testMode) claimFixedSurface();
      showStage('email', false);
      ensureTurnstile();
      emit('eligible', 'teaser');
      emit('teaser_viewed', 'teaser');
      if (eligibility.reason !== 'cooldown' && teaserDismissedAt <= 0) {
        timers.push(setTimer(function () { open('auto'); }, Math.max(0, Number(root.dataset.delayMs) || 5000)));
      }
    }

    on(teaser, 'click', function () { open(teaser); });
    on(teaserDismiss, 'click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      dismissTeaser();
    });
    on(root.querySelector('[data-close-popup]'), 'click', function () { close('button'); });
    on(emailForm, 'submit', submitEmail);
    on(emailInput, 'input', startInteraction);
    on(root.querySelector('[data-copy-coupon]'), 'click', function () {
      copyCoupon(root.querySelector('[data-copy-label]'), root.querySelector('[data-coupon] [data-coupon-code]'));
    });
    on(root.querySelector('[data-copy-profile-coupon]'), 'click', function () {
      copyCoupon(root.querySelector('[data-profile-copy-label]'), root.querySelector('[data-profile-coupon-chip] [data-coupon-code]'));
    });
    on(root.querySelector('[data-continue-profile]'), 'click', startProfile);
    on(root.querySelector('[data-profile-back]'), 'click', goBack);
    on(root.querySelector('[data-finish-reward]'), 'click', showDone);
    on(root.querySelector('[data-close-done]'), 'click', function () { close('done'); });
    on(root.querySelector('[data-scratch-fallback]'), 'click', function () {
      startInteraction();
      emit('scratch_started', 'modal');
      if (scratchInstance && typeof scratchInstance.reveal === 'function') scratchInstance.reveal();
      else celebrateScratch('button');
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-brand-choice]'), function (button) {
      on(button, 'click', function () { chooseBrand(button.dataset.brandChoice); });
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-usecase-choice]'), function (button) {
      on(button, 'click', function () { chooseUseCase(button.dataset.usecaseChoice); });
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-material-choice]'), function (button) {
      on(button, 'click', function () { chooseMaterial(button.dataset.materialChoice); });
    });
    on(root.querySelector('[data-model-search]'), 'input', renderModelOptions);
    on(root.querySelector('[data-model-unlisted]'), 'click', function () { chooseModel('Unlisted model'); });
    on(root.querySelector('[data-size-not-sure]'), 'click', function () { chooseSize('not_sure'); });
    on(root.querySelector('[data-profile-retry]'), 'click', retryProfileSave);
    on(root.querySelector('[data-profile-continue]'), 'click', continueWithoutProfileAnswer);
    on(root.querySelector('[data-profile-finish-error]'), 'click', function () {
      pendingProfileSave = null;
      profileErrorPanel(false);
      showDone();
    });
    on(root, 'click', function (event) {
      var modelButton = event.target.closest && event.target.closest('[data-model-choice]');
      if (modelButton && root.contains(modelButton)) { chooseModel(modelButton.dataset.modelChoice); return; }
      var sizeButton = event.target.closest && event.target.closest('[data-size-choice]');
      if (sizeButton && root.contains(sizeButton)) chooseSize(sizeButton.dataset.sizeChoice);
    });
    on(overlay, 'click', function (event) { if (event.target === overlay) close('backdrop'); });
    on(doc, 'keydown', function (event) {
      if (overlay.hidden) return;
      if (event.key === 'Escape') { event.preventDefault(); close('escape'); return; }
      if (event.key !== 'Tab') return;
      var focusable = focusableElements();
      if (!focusable.length) { event.preventDefault(); dialog.focus(); return; }
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && doc.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && doc.activeElement === last) { event.preventDefault(); first.focus(); }
    });

    var identified = dependencies.identified;
    if (typeof identified === 'boolean') initialize(identified);
    else if (win.klaviyo && typeof win.klaviyo.isIdentified === 'function') {
      try {
        Promise.resolve(win.klaviyo.isIdentified()).then(function (value) { initialize(value === true); }, function () { initialize(false); });
      } catch (_error) { initialize(false); }
    } else initialize(false);

    function destroy() {
      if (state.destroyed) return;
      state.destroyed = true;
      listeners.splice(0).forEach(function (remove) { remove(); });
      timers.splice(0).forEach(function (timer) { clearTimer(timer); });
      if (scratchInstance && typeof scratchInstance.destroy === 'function') scratchInstance.destroy();
      doc.body.classList.remove('nbb-wp-scroll-locked');
      if (activeInstance === instance) activeInstance = null;
    }

    var instance = {
      open: open,
      close: close,
      destroy: destroy,
      state: function () { return Object.assign({}, state, { profile: Object.assign({}, state.profile) }); }
    };
    activeInstance = instance;
    return instance;
  }

  function destroy() {
    if (activeInstance) activeInstance.destroy();
  }

  return { create: create, destroy: destroy };
});
